import ActionDialog from "components/reusable/ActionDialog";
import ScrollableWalletsDesktop from "components/ScrollableWalletsDesktop";
import AuthContext from "context/AuthContext";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { default as BottomNav } from "../../../components/BottomNav";
import DesktopWalletStatement from "./WalletStatement/DesktopWalletStatement";

function DashboardDesktop() {
  const { t } = useTranslation();

  const { language, user } = useContext(AuthContext);
  const [showPostaShqiptareAlertDialog, setShowPostaShqiptareAlertDialog] = useState(false);

  return (
    <>
      <div>
        <div className="flex h-[3rem] justify-end items-center m-4">
          <div className="flex gap-2 items-center">
            <div className="relative"></div>
          </div>
        </div>

        <div className="flex w-full justify-center ">
          <div className="container grid grid-cols-3 xl:grid-cols-4 gap-5">
            <div className="col-span-3 mx-4">
              <ScrollableWalletsDesktop sideBar={false} />
              <DesktopWalletStatement walletRefresh={user.wallet_id} />
            </div>
            <div className="col-span-3 lg:mx-4 xl:mx-0 xl:col-span-1">
              <div className="p-4 bg-backdrop rounded-3xl pb-[6rem] md:pb-0">
                <div className="mt-2 pb-4">
                  <div className="text-lg mx-2 font-medium pb-2">{t("O_OFFERS_AND_PROMO_CODES")}</div>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-1 gap-2">
                    <img
                      className="col-span-1 p-2 rounded-3xl aspect-16/9 w-full cursor-pointer"
                      alt="Post"
                      style={{ aspectRatio: "16/9" }}
                      src={language === 1 ? "./images/promotions/post_en.png" : "./images/promotions/post_al.png"}
                      onClick={() => {
                        setShowPostaShqiptareAlertDialog(true);
                      }}
                    />
                    <img
                      className="col-span-1 p-2 rounded-3xl aspect-16/9 w-full"
                      style={{ aspectRatio: "16/9" }}
                      alt="Loan"
                      src={language === 1 ? "./images/promotions/loan_en.png" : "./images/promotions/loan_al.png"}
                    />
                    <img
                      className="col-span-1 p-2 rounded-3xl aspect-16/9 w-full"
                      style={{ aspectRatio: "16/9" }}
                      alt="Merchant"
                      src={language === 1 ? "./images/promotions/merchant_en.png" : "./images/promotions/merchant_al.png"}
                    />
                  </div>
                </div>
              </div>
              {showPostaShqiptareAlertDialog && (
                <ActionDialog
                  open={showPostaShqiptareAlertDialog}
                  title={t("ALBANIAN_POST")}
                  onClose={() => {
                    setShowPostaShqiptareAlertDialog(false);
                  }}
                >
                  <div className="font-medium flex justify-center items-center text-center p-4">{t("ALBANIAN_POST_INSERT_INFO")}</div>
                </ActionDialog>
              )}
            </div>
          </div>
        </div>
      </div>
      <BottomNav />
    </>
  );
}

export default DashboardDesktop;
